import { ButtonHTMLAttributes, useEffect, useRef, useState } from 'react';

import { clsx } from 'clsx';

import { RoundedArrow } from '../svg/RoundedArrow';

type CopyButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick: () => void;
};

export const CopyButton = ({
  onClick,
  children,
  className,
  ...props
}: CopyButtonProps) => {
  const [isCopiedTextVisible, setIsCopiedTextVisible] = useState(false);
  const isMountedRef = useRef(false);

  const handleClick = () => {
    setIsCopiedTextVisible(true);

    onClick();
  };

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  });

  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (isCopiedTextVisible) {
      const copyTimeout = setTimeout(() => {
        if (!isMountedRef.current) return;

        setIsCopiedTextVisible(false);
      }, 1000);

      return () => {
        clearTimeout(copyTimeout);
      };
    }
  }, [isCopiedTextVisible]);

  return (
    <button
      {...props}
      className={clsx('relative flex items-center gap-s', className)}
      type="button"
      onClick={handleClick}
    >
      {children}
      {isCopiedTextVisible ? (
        <div className="absolute -bottom-[0.8rem] left-1/2 z-[3] flex translate-x-[-50%] translate-y-full items-center justify-center rounded-s bg-white px-[15px] py-[5px] font-bold text-[black] no-underline shadow-copy-popup m800:px-[30px] m800:py-[15px]">
          <RoundedArrow className="absolute -top-[10px] rotate-180" />
          Copied!
        </div>
      ) : null}
    </button>
  );
};
